module.exports = __webpack_public_path__ + "static/media/gift_pl_two.0f6d92c4.png";